import React from "react"
import FieldProto_ConditionForm from "../../../../proto/render/condition/condition-form";
import ConditionTypeSelector from "../../../../proto/render/condition/condition-type-selector";
import SelectMultiGenericNew from "../../../../../gd-ui/select-multi-generic-new/select-multi-generic-new";
import FieldStatus_MultiselectPopoverOption from "../../../../generic/status/components/multiselect/option";
import FieldProjectStatus_MultiselectValueNotEmpty from "../components/multiselect/value-not-empty";

const debug = false
// const debug = "FieldTaskStatus_ConditionForm"

export default class FieldProjectStatus_ConditionForm extends FieldProto_ConditionForm {

    render() {
        debug && console.log(debug, 'render', this.state)

        const options = this.props.field.options || []

        return (
            <React.Fragment>
                <ConditionTypeSelector field    = {this.props.field}
                                       value    = {this.props.condition.type}
                                       onChange = {this.onChangeType}/>

                <SelectMultiGenericNew className                        = "selector w-250 m-l-10"
                                       options                          = {options}
                                       values                           = {this.props.condition.value}
                                       popoverScrollContainerClasses    = "max-h-200 max-w-300"
                                       valueComponent                   = {FieldProjectStatus_MultiselectValueNotEmpty}
                                       popoverOptionComponent           = {FieldStatus_MultiselectPopoverOption}
                                       isSearchable                     = {true}
                                       // disabled                         = {disabled}
                                       onChange                         = {this.onChangeValue}/>
            </React.Fragment>
        )
    }
}
